export const FOUNDER_ADMIN_EMAILS = [
  'admin@petronexus.com',
  'kim@petro-nexus.com',
  'kim@petronexus.co.za',
  'kimmagidhi16@gmail.com',
];

export const OBSERVABILITY_ADMIN_EMAILS = ['admin@petronexus.com'];

const ADMIN_WORKSPACE_EXACT_PATHS = new Set(['/admin', '/observability', '/profile']);

export function normalizeEmail(email: string | null | undefined): string {
  return (email ?? '').trim().toLowerCase();
}

export function isAllowedEmail(email: string | null | undefined, allowedEmails: string[]): boolean {
  const normalized = normalizeEmail(email);
  return allowedEmails.some((allowed) => normalizeEmail(allowed) === normalized);
}

export function isFounderAdminEmail(email: string | null | undefined): boolean {
  return isAllowedEmail(email, FOUNDER_ADMIN_EMAILS);
}

export function isAdminWorkspacePath(pathname: string): boolean {
  return pathname.startsWith('/admin/') || ADMIN_WORKSPACE_EXACT_PATHS.has(pathname);
}

export function shouldUseTenantWorkspace(
  user: { email?: string | null; tenantId?: string | null } | null | undefined,
): boolean {
  return Boolean(user?.tenantId) && !isFounderAdminEmail(user?.email);
}
